<template>
  <div class="bg-grey" style="padding-top: 16px;">
    <div class="bg-white" style="flex: 1; padding: 16px;box-sizing: border-box;">

    <div style="display: grid;grid-template-columns: repeat(1,1fr);">
      <div v-for="item in list" :key="item.newsId" class="item" @click="toDetails(item)">
        <img :src="item.newsImage" alt="expert photo"
          style="width: 150px;height: 150px;object-fit: cover;margin-right: 16px;"
        />
        <div style="flex: 1; display: flex;flex-direction: column;justify-content: space-between;">
          <div style="font-weight: bold;margin-bottom: 4px; font-size: 24px;">{{ L(item.newsTitle) }}</div>
          <div class="text-clamp">
            {{ item.brief }}
          </div>
          <div style="display: flex;align-items: center;justify-content: flex-end;font-size: 0.8em">
            <div style="color: #DC000C;margin-right: 16px;">{{ L(item.author) }}</div>
            <div style="color: rgba(0, 0, 0, .7);">
              {{ item.releaseTime.slice(0, 10) }}
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    toDetails(item, url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          path: `/expert-details/${item.newsId}`,
        });
      }
    },
  }
}
</script>

<style scoped>
.item {
  display: flex; margin-bottom: 16px;padding-bottom: 16px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.item:last-child {
  border-bottom-width: 0;
  margin-bottom: 0;
}

.text-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/views/expert/list.vue